import { render } from "./InstitucionalView.vue?vue&type=template&id=72cf1ef8&scoped=true"
import script from "./InstitucionalView.vue?vue&type=script&lang=js"
export * from "./InstitucionalView.vue?vue&type=script&lang=js"

import "./InstitucionalView.vue?vue&type=style&index=0&id=72cf1ef8&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cf1ef8"]])

export default __exports__